import React, { useState, useEffect } from "react";
import "../../css/CrearFirmaElectronica.css";
import checkIcon from "../../assets/check.png";
import BotonExpandible from "../components/BotonExpandible";
import ComponenteContrasenia from './ComponenteContrasenia';
import MenuUsuario from "./MenuUsuario";

const CrearFirmaElectronica = ({ onFirmaCreada,setModalVisible,handleloadfirmas  }) => {
  const [nombre, setNombre] = useState("");
  const [correo, setCorreo] = useState("");
  const [clave, setClave] = useState("");
  const [confirmarClave, setConfirmarClave] = useState("");
  const [formValid, setFormValid] = useState(false);
  const [modalExito, setModalExito] = useState({ show: false });
  const [modalError, setModalError] = useState({ show: false, message: "" });
  const [formVisible, setFormVisible] = useState(true);
  const [isLoading, setIsLoading] = useState(false); 
  const [claveVisible, setClaveVisible] = useState(false); // Para mostrar/ocultar la clave
  const [confirmarClaveVisible, setConfirmarClaveVisible] = useState(false); // Para mostrar/ocultar la confirmación
  const expresion=/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d@*._-]{8,16}$/;
  const [nombres, setNombres] = useState("");
  const [apellidos, setApellidos] = useState("");
  const [userrr, setUserrr] = useState("");
  const [isUpdateePss, setIsUpdateePss] = useState(false);
  const [aceptoTerminos, setAceptoTerminos] = useState(false);
  const [modalTerminos, setModalTerminos] = useState(false);
  const [contra, setContra] = useState({
              contrasena: "",
              contrasenaactual: "",
                contrasenaCumple:false,
                repetirContraCumple:false,
            }); 
            
  useEffect(() => {
    let token = sessionStorage.getItem("access_token");
    if (!token) {
        token = sessionStorage.getItem("token_nueva_cuenta");
    }
    if (!token) {
        return;
    }
    try {
        const payload = token.split(".")[1];
        const decodedPayload = JSON.parse(
            atob(payload.replace(/-/g, "+").replace(/_/g, "/"))
        );
        if (decodedPayload.Nombres || decodedPayload.Apellidos) {
            const nombres = decodedPayload.Nombres || "";
            const apellidos = decodedPayload.Apellidos || "";
            setNombres(nombres);
            setApellidos(apellidos);
            setNombre(`${nombres} ${apellidos}`.trim());
            if (decodedPayload.Email) {
                setCorreo(decodedPayload.Email);
            }
            if (decodedPayload.User) {
                setUserrr(decodedPayload.User);
            }
        } else {
            if (decodedPayload.name) {
                setNombre(decodedPayload.name);
                setNombres(decodedPayload.name);
                setApellidos(decodedPayload.name);
            }
            if (decodedPayload.upn) {
                setCorreo(decodedPayload.upn);
                setUserrr(decodedPayload.upn.split("@")[0]);
            }
        }
    } catch (e) {
    }
}, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if(contra == null){
       setModalError({ show: true, message: "Las claves no coinciden" });
       return;
    }
    if(contra.contrasena=="" || contra.contrasena==null){
      setModalError({ show: true, message: "La contraseña no puede quedar vacía" });
      return;
    }
    if(!contra.contrasenaCumple || !contra.repetirContraCumple){
      setModalError({ show: true, message: "Las contraseñas no cumplen" });
      return;
    }
    // if (clave !== confirmarClave) {
    //   //alert("Las claves no coinciden");
    //   setModalError({ show: true, message: "Las claves no coinciden" });

    //   return;
    // }
    if (!contra.contrasenaCumple || !contra.repetirContraCumple) {
      setModalError({ show: true, message: "La contraseña no cumple con las reglas o no coinciden" });
      return;
    }

    var token = sessionStorage.getItem("access_token");
    if(token == null){
      token =  sessionStorage.getItem("token_nueva_cuenta");
    }
    if (!token) {
      //alert("No se encontró el token de acceso");
      setModalError({ show: true, message: "No se encontró el token de acceso" });
      return;
    }

    const body = JSON.stringify({ password: contra.contrasena });

    try {
      setIsLoading(true); // 👈 mostrar loading
      const response = await fetch(`${process.env.REACT_APP_API_FIRMAS}/FirmaElectronica/CrearArchivo`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body,
      });

      const data = await response.json();

      if (response.ok) {
        setModalExito({ show: true });

        // ✅ AGREGAR: Llamar al callback del componente padre
        if (onFirmaCreada) {
          // Pequeño delay para que el usuario vea el modal de éxito
          setTimeout(() => {
            onFirmaCreada();
          }, 1500);
        }
      } else {
        //alert(`Error al crear la firma: ${data.status?.messages?.[0] ?? "Error"}`);
        setModalError({ show: true, message: `Error al crear la firma: ${data.status?.messages?.[0] ?? "Error"}` });
      }
    } catch (error) {
      // console.error("Error de conexión o solicitud:", error);
      //alert("Hubo un error al conectar con la API");
      setModalError({ show: true, message: "Hubo un error al conectar con la API" });
    } finally {
      setIsLoading(false); // 👈 ocultar loading SIEMPRE
    }
  };
  const cambiarEstado = (contraActual,valor,contraCumple,repetirContraCumple) => {
    
    setContra({
      contrasena: valor,
        contrasenaactual: contraActual,
        contrasenaCumple:contraCumple,
      repetirContraCumple:repetirContraCumple
    });
  };
  const renderModalExito = () =>
    modalExito.show && (
      <div className="modal-background" id="crear_firma_success" style={{ zIndex: 9999 }}>
        <div className="modal-container">
          <img
            src={checkIcon}
            alt="Éxito"
            style={{ width: 48, height: 48, margin: "0 auto", display: "block", marginBottom: 16 }}
          />
          <div style={{ fontWeight: 500, fontSize: 18, marginBottom: 8 }}>
            Su firma ha sido creada con éxito
          </div>
          <button className="btn-confirmar"  onClick={() => {
              setModalExito({ show: false });
              setModalVisible(false); 
              if(handleloadfirmas) handleloadfirmas(); 
            }}
          >
            ACEPTAR
          </button>
        </div>
      </div>
    );
    const handleAceptarTerminosDesdeModal = () => {
      setAceptoTerminos(true); // Marca el check automáticamente
      setModalTerminos(false); // Cierra el modal
    };
    const renderModalError = () =>
      modalError.show && (
        <div className="modal-background" id="crear_firma_fail" style={{ zIndex: 9999 }}>
          <div className="modal-container" style={{ maxWidth: 400, padding: 32 }}>
            <div style={{ fontWeight: 500, fontSize: 18, marginBottom: 8 }}>
              Error: {modalError.message}
            </div>
            <button
              className="btn-confirmar"
              onClick={() => setModalError({ show: false })}
            >
              ACEPTAR
            </button>
          </div>
        </div>
    );

  const validateForm = () => {
    setFormValid(clave === confirmarClave && clave !== "" && confirmarClave !== "");
  };
  const closeModal = () => {
    setModalTerminos(false);
  };
  const handleClaveChange = (e) => setClave(e.target.value);
  const handleConfirmarClaveChange = (e) => setConfirmarClave(e.target.value);

  const toggleClaveVisibility = () => setClaveVisible(!claveVisible);
  const toggleConfirmarClaveVisibility = () => setConfirmarClaveVisible(!confirmarClaveVisible);

  useEffect(() => {
    validateForm();
  }, [clave, confirmarClave]);

  return (
    <div className="mt-5">
      <div className="container" aria-busy={isLoading} aria-disabled={isLoading}>
        <div className="col-12 text-justify mt-2 mb-2" 
          
        >
            <BotonExpandible 
                mensaje={
                <div className=" col-xl-12">
                    <p className="text-justify">
                        <b>REGLAS QUE DEBE CUMPLIR LA CONTRASEÑA:</b>
                    </p>
                    <ul className="text-start">
                        <li>Tener mínimo 8 caracteres y máximo 16.</li>
                        <li>Tener al menos una letra minúscula.</li>
                        <li>Tener al menos una letra mayúscula.</li>
                        <li>Tener al menos un número.</li>
                        <li>Solo permite lo siguientes caracteres especiales: @ , * , . , _ , - </li>
                        <li>La contraseña no puede ser similar al usuario: {correo.split("@")[0]}.</li>
                        {/* <li>La contraseña no puede contener las siguientes palabras: {this.state.nombresRegla }.</li> */}
                    </ul>
                </div>
                }
            />
        </div>
        {formVisible && (
          <form className="form" onSubmit={handleSubmit}>
            <div className="row">

              <div className="inputGroup">
                <label className="label">Nombre / Apellido</label>
                <input
                  type="text"
                  name="nombre"
                  placeholder="Nombre Nombre Apellido Apellido"
                  className="input"
                  value={nombre}
                  readOnly
                  disabled={isLoading} 
                />
              </div>
              <div className="inputGroup">
                <label className="label">Correo</label>
                <input
                  type="email"
                  name="correo"
                  placeholder="user@gmail.com"
                  className="input"
                  value={correo}
                  readOnly
                  disabled={isLoading}
                />
              </div>
            </div>
            <ComponenteContrasenia
              columnas="col-12"
              cambiarEstado={cambiarEstado}
              expresionRegular={expresion}
              nombres={nombres}
              apellidos={apellidos}
              usuario={userrr}
              isUpdateePss={isUpdateePss}
            >
            </ComponenteContrasenia>
            
            {/* <div className="inputGroup">
              <label className="label">Clave de la firma</label>
              
              <div className="password-wrapper">
                <input
                  type={claveVisible ? "text" : "password"}
                  name="clave"
                  className="input"
                  value={clave}
                  onChange={handleClaveChange}
                  disabled={isLoading}
                />
                <img
                  src={claveVisible ? eyeOffIcon : eyeIcon}
                  alt="Toggle visibility"
                  className="eye-icon"
                  onClick={toggleClaveVisibility}
                />
              </div>
            </div>
            <div className="inputGroup">
              <label className="label">Confirmar clave de la firma</label>
              <div className="password-wrapper">
                <input
                  type={confirmarClaveVisible ? "text" : "password"}
                  name="confirmarClave"
                  className="input"
                  value={confirmarClave}
                  onChange={handleConfirmarClaveChange}
                  disabled={isLoading}
                />
                <img
                  src={confirmarClaveVisible ? eyeOffIcon : eyeIcon}
                  alt="Toggle visibility"
                  className="eye-icon"
                  onClick={toggleConfirmarClaveVisibility}
                />
              </div>

            </div> */}

            {/* Mensaje dinámico sobre el botón */}
            {/* {clave && confirmarClave && (
              <p
                style={{
                  color: clave === confirmarClave ? "green" : "red",
                  fontSize: "14px",
                  marginBottom: "8px",
                  fontWeight: 500,
                }}
              >
                {clave === confirmarClave ? "✔ Las claves coinciden" : "✖ Las claves no coinciden"}
              </p>
            )} */}
            {modalTerminos && (
              <div className="modal-background" style={{ zIndex: 10000 }}>
                <div className="modal-container">
                  <div className="modal-header1">
                    <h4>Acuerdo de Uso y Administración de la Firma Electrónica - ESPOL</h4>
                    <button className="modal-close" onClick={closeModal}>&times;</button>
                  </div>                  
                  <div className="text-start">
                    <p>El presente acuerdo establece las condiciones de uso, administración y responsabilidades asociadas a la firma electrónica institucional proporcionada por la Escuela Superior Politécnica del Litoral (ESPOL), para el desarrollo de actividades y trámites internos.</p>
                    <h5>1. Resguardo y Ámbito de Aplicación</h5>
                    <ul>
                      <li><strong>Administración Institucional:</strong> Los componentes técnicos asociados a la firma electrónica institucional serán generados y administrados de forma segura dentro de la infraestructura tecnológica de la ESPOL, conforme a sus políticas de seguridad de la información.</li>
                      <li><strong>Uso Restringido:</strong> La firma electrónica institucional tendrá uso exclusivo para trámites, documentos y procesos internos de la ESPOL. No podrá ser utilizada para actuaciones externas ni para fines ajenos a las competencias institucionales.</li>
                      
                    </ul>
                    <h5>2. Gestión de la Clave y Confidencialidad</h5>
                    <ul>
                      <li><strong>Responsabilidad del Usuario:</strong> La clave asociada a la firma electónica es personal e intransferible. El usuario es el único responsable de su confidencialidad, custodia y uso adecuado.</li>
                      <li><strong>No Almacenamiento de Claves: </strong> La ESPOL no almacena ni conoce la clave de la firma electónica. Por motivos de seguridad, no existen mecanismos de recuperación de la clave en caso de olvido.</li>
                      <li><strong>Creación de la firma:</strong> Al momento de generación de la firma electrónica, el sistema enviará un correo electrónico automático a la cuenta institucional del usuario confirmando la creación de la firma, sin que ello implique la generación, custodia o conocimiento de la clave por parte de la ESPOL.</li>
                    </ul>
                    <h5>3. Vigencia y Renovación</h5>
                    <ul>
                      <li><strong>Periodo de Validez:</strong> Cada firma tendrá una vigencia de <strong>un (1) año calendario</strong> a partir de la fecha de su creación.</li>
                      <li><strong>Renovación Anticipada:</strong> El usuario podrá gestionar la renovación de su firma electrónica dentro del plazo que establezca la plataforma institucional, previo a su fecha de caducidad.</li>                      
                    </ul>
                    <h5>4. Políticas en Caso de Olvido de Contraseña</h5>
                    <p>Dado que la clave no puede ser recuperada, se establece el siguiente lineamiento:</p>
                    <ul>
                      <li><strong>Renovaciones autónomas:</strong> Se permitirá hasta un máximo de dos (2) renovaciones adicionales por olvido de clave, las cuales podrán ser gestionadas directamente por el usuario a través de la plataforma institucional.</li>
                      <li><strong>Renovaciones posteriores:</strong> En caso de requerir una tercera o posterior renovación por olvido de clave, el usuario deberá acudir presencialmente a la Gerencia de Tecnologías y Sistemas de Información (GTSI), a fin de validar su identidad y habilitar la emisión de una nueva firma electrónica simple institucional.</li>                      
                    </ul>
                    <h5>5. Aceptación y responsabilidad</h5>
                    <p>El uso de la firma electrónica institucional implica la aceptación expresa de las condiciones establecidas en el presente acuerdo, así como el cumplimiento de la normativa interna de la ESPOL y de las disposiciones aplicables en materia de seguridad de la información y protección de datos personales.</p>
                  </div>
                  <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
                    <button 
                      type="button"
                      className="btn btn-secondary" 
                      style={{borderRadius: "18px"}}
                      onClick={() => setModalTerminos(false)}
                    >
                      CANCELAR
                    </button>
                    <button 
                      type="button"
                      className="btn-confirmar" 
                      onClick={handleAceptarTerminosDesdeModal}
                    >
                      ACEPTAR
                    </button>
                  </div>
                </div>
              </div>
            )}
            <div className="inputGroup" style={{ flexDirection: "row"}}>
              <input
                type="checkbox"
                id="terminos"
                checked={aceptoTerminos}
                onChange={(e) => setAceptoTerminos(e.target.checked)}
                disabled={isLoading}
                style={{ width: "18px", height: "18px", cursor: "pointer" }}
              />
              <label htmlFor="" className="label" style={{ marginBottom: 0 }}>
                Acepto los{" "}
                <span 
                  onClick={(e) => { e.preventDefault(); setModalTerminos(true); }} 
                  style={{ color: "#007bff", textDecoration: "underline", cursor: "pointer" }}
                >
                  términos y condiciones
                </span>
              </label>
            </div>
            <button
              type="submit"
              // className={`modal-btn-submit ${!formValid ? "disabled" : ""}`}
              // disabled={!formValid || isLoading}
              disabled={isLoading || !aceptoTerminos ||
              !(
                  contra.contrasenaCumple &&
                  contra.repetirContraCumple )}
              className={!isLoading && (
                  contra.contrasenaCumple &&
                  contra.repetirContraCumple && aceptoTerminos)  ?
                  "modal-btn-submit" : "modal-btn-submit disabled"}
            >
              {isLoading ? "Creando firma." : "CREAR"} {/* 👈 texto del botón cambia */}
            </button>
          </form>
        )}
      </div>

      {/* Overlay de Loading */}
      {isLoading && (
        <div className="loading-overlay">
          <div className="loading-card">
            <div className="spinner" aria-hidden="true" />
            <div className="loading-text">Cargando...</div>
          </div>
        </div>
      )}

      {renderModalExito()}
    </div>
  );
};

export default CrearFirmaElectronica;
